export { default as Component } from "./Row.svelte";
export const modes = ["static"];
